// extracted by mini-css-extract-plugin
export default {"postsBlock":"MyPost_postsBlock__RgVM3","posts":"MyPost_posts__5LT2+"};